import { observable, makeObservable } from 'mobx';
import { IUserProfileModel } from 'interfaces/user/IUserProfileModel';

class ProfileStore {
  constructor() {
    makeObservable(this);
  }

  @observable userId = '';

  @observable firstName = '';

  @observable fullName = '';

  @observable lastName = '';

  @observable email = '';

  @observable photoUrl: string | null = null;

  @observable isLoggingOut = false;

  @observable preferredLanguage: string | null = null;

  @observable preferredUnitSystem: string | null = null;

  @observable public loaded = false;

  setLogoutAction(value: boolean) {
    this.isLoggingOut = value;
  }

  setUserData(data: IUserProfileModel) {
    this.userId = data.userId;
    this.email = data.email;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.photoUrl = data.profilePhotoUrl;
    this.preferredLanguage = data.preferredLanguage;
    this.preferredUnitSystem = data.preferredUnitSystem || 'imperial';

    if (!this.firstName && !this.lastName) {
      this.fullName = '';
    } else {
      this.fullName = (data.firstName == null ? '' : `${data.firstName} `) + (data.lastName || '');
    }
    this.loaded = true;
  }

  setUnknownUser() {
    this.loaded = false;
    this.fullName = 'Unknown user';
  }

  public async ensureDataAvailability() {
    if (this.loaded) {
      return;
    }
    await this.LoadData();
  }

  public async SaveLanguageData(preferredLanguage: string | null = null, preferredUnitSystem: string | null = null): Promise<boolean> {
      await this.LoadData();
      return true;
  }

  private async LoadData() {
    this.setUnknownUser();
  }
}

export const profile = new ProfileStore();
